import * as Cookies from "js-cookie";
import { AuthSession, createSession } from "../models/AuthSession";

const jwt_decode = require("jwt-decode");

const COOKIE_AUTH_1 = "upload-auth-1";
//const COOKIE_AUTH_2 = "upload-auth-2";

const COOKIE_ROLE_ADMIN = "Administrator";
const COOKIE_ROLE_UPLOAD = "Upload";

/**
 * Initialize a session from a special cookie
 *
 * The server will provide two auth cookies
 * cookie 1: JWT header + payload (expiry)
 * cookie 2: JWT signature (httpOnly)
 *
 * We only have access to cookie 1 and can decode it in order
 * to get the payload data (roles).
 *
 * The strategie is designed after:
 * https://medium.com/lightrail/getting-token-authentication-right-in-a-stateless-single-page-application-57d0c6474e3
 */

export const getCurrentSession = (): AuthSession => {
  const cookie = Cookies.get(COOKIE_AUTH_1);
  if (cookie === undefined) return createSession(); // default session

  // decode JWT token
  // session cookie payload
  // username: jwt['jti']
  // roles: jwt['data']['roles']
  // issued: jwt['iat']
  // expires: jwt['exp']
  try {
    const decoded = jwt_decode(cookie);

    const username = decoded["jti"];
    const roles = decoded["data"].roles;
    const issued = new Date(decoded["iat"] * 1000);
    const expires = new Date(decoded["exp"] * 1000);
    return createSession(true, username, roles, issued, expires);
  } catch (error) {
    // log for now
    // TODO: remove log for production
    // console.error(error);
    return createSession(); // default session
  }
};

export const isAdmin = (session: AuthSession): boolean => {
  return session.authenticated && session.roles.includes(COOKIE_ROLE_ADMIN);
};

export const canUpload = (session: AuthSession) => {
  return session.authenticated && session.roles.includes(COOKIE_ROLE_UPLOAD);
};

export const logout = () => {
  // just remove the cookie 1
  Cookies.remove(COOKIE_AUTH_1);
};
